const randomColors = [
  "#5D8AA8",
  "#6CB4EE",
  "#0080FF",
  "#89CFF0",
  "#003262",
  "#318CE7",
  "#1F75FE",
  "#0093AF",
  "#0087BD",
  "#0070FF",
  "#4997D0",
  "#246BCE",
  "#007BA7",
  "#468fea",
  "#B9D9EB",
  "#6495ED",
  "#00BFFF",
  "#1F305E",
  "#1E90FF",
  "#0072BB",
  "#1164B4",
  "#0076B6",
  "#8AB9F1",
  "#26619C",
  "#ADD8E6",
  "#87CEFA",
  "#73C2FB",
  "#87D3F8",
  "#45B1E8",
  "#224C98",
  "#002387",
  "#002366",
  "#4169E1",
  "#76ABDF",
  "#082567",
  "#5D89BA",
  "#87CEEB",
  "#0070BB",
  "#4682B4",
  "#0059CF",
  "#2D68C4",
  "#3E8EDE",
  "#4B92DB",
  "#011F5B",
  "#AFDBF5",
  "#7C9ED9",
  "#00356B"
];

export {
  randomColors
}